import Agent from "core/services/api";
import { Result } from "core/models";
import { UploadFile, UploadFileEntity } from "core/models/UploadFile";

const uploadFileWrite = async (
    accessToken: string,
    fileID: number,
    buffer: ArrayBuffer,
): Promise<Result<UploadFile, string>> => {
    const endpoint = `file/createwrite/v1/${fileID}`;
    const headers = new Headers();
    headers.append("Authorization", accessToken);
    headers.append("Content-Type", "application/octet-stream");
    const response = await Agent.post<UploadFileEntity>(
        endpoint,
        buffer,
        headers,
        "file",
    );
    if (!response.resultObject) {
        return {
            value: undefined,
            error: undefined,
        };
    }
    return {
        value: new UploadFile(response.resultObject),
        error: undefined,
    };
};

const uploadFileClose = async (
    accessToken: string,
    fileID: number,
): Promise<Result<UploadFile, string>> => {
    const request = {
        id: fileID,
    };
    const headers = new Headers();
    headers.append("Authorization", accessToken);
    const response = await Agent.post<UploadFileEntity>(
        "file/createclose/v1",
        request,
        headers,
        "file",
    );
    if (!response.resultObject) {
        return {
            value: undefined,
            error: undefined,
        };
    }
    return {
        value: new UploadFile(response.resultObject),
        error: undefined,
    };
};

export { uploadFileWrite, uploadFileClose };
